import type { CurrencyCode } from "@beautypie/core";
import { subscribe } from "@shared/utils.events";
import type { CancellationFeedback } from "packages/membership/chakra/MyAccount/MyMembership/active-membership/shared/types";
import { userVar } from "lib/user";
import type { ItemType, SubscriptionType } from "@shared/graphql.types";
import {
  addFromWishlistTracking,
  removeFromWishlistTracking,
  trackAddToBasket,
  trackMembershipCancelled,
  trackMembershipExtended,
  trackRemoveFromBasket
} from "utils/gtm";

export const trackApiEvents = (currencyCode: CurrencyCode): void => {
  // I think we are no longer hitting this because we are not hitting the dispatch fn in addBasketItems.ts
  subscribe("addToBag", (payload) => {
    const { items, event_id } = payload as {
      items: ItemType[];
      event_id: string;
    };

    if (!Array.isArray(items) || items.length === 0) return;

    const isBundle = false;

    trackAddToBasket(items as ItemType[], isBundle, currencyCode, event_id);
  });

  subscribe("removeFromBag", (payload) => {
    const { items = [], event_id } = payload as {
      items: ItemType[];
      event_id: string;
    };
    const { basket } = userVar();
    const gtmInputs = (items as ItemType[]).map((input) => {
      const position = basket.findIndex(({ id }) => id === input.id);
      return { input, position: position + 1 };
    });

    trackRemoveFromBasket(gtmInputs, currencyCode, event_id);
  });

  subscribe("addToWishlist", (payload) => {
    const { item } = payload as { item: ItemType };
    addFromWishlistTracking(item.variant?.title, item.variant?.sku);
  });
  subscribe("removeFromWishlist", (payload) => {
    const { item } = payload as { item: ItemType };
    removeFromWishlistTracking(item.variant?.title, item.variant?.sku);
  });

  subscribe("membershipCancelled", (payload) => {
    trackMembershipCancelled(
      payload as {
        customerNumber: string;
        subscription: SubscriptionType;
        cancellationFeedback: CancellationFeedback;
      }
    );
  });

  subscribe("membershipExtended", (payload) => {
    trackMembershipExtended(
      payload as {
        customerNumber: string;
        subscription: SubscriptionType;
      }
    );
  });
};
